import { isErrorResponse } from '../types/ErrorResponseTypes'
import ApiService from './apiService'
import http from '../http-common'
import { AxiosResponse } from 'axios'
import { isUserActionsResponse } from '@/types/userActions/userActionsResponse'

class UserActionsService extends ApiService {
  async getUserActions(relationContactId: number): Promise<any> {
    try {
      return await http.bss
        .get(`/user/${relationContactId}/userActions`)
        .then((response: AxiosResponse) => {
          console.log(`response from getUserActions: ${JSON.stringify(response)}`)
          const parsedResponse = this.parseResponse(response)

          if (isErrorResponse(parsedResponse) || isUserActionsResponse(parsedResponse)) {
            return parsedResponse
          }
          return parsedResponse
        })
        .catch((error) => {
          throw Error(error)
        })
    } catch (error) {
      console.error('there is an api issue')
    }
  }
}

export default new UserActionsService()
